import React from "react";
import { Field } from "redux-form";
import RenderFormFieldNew from "./RenderFormFieldNew";
import { phone } from "@components/validation";

const NewPhoneNumber = () => (
  <div>
    <Field
      name="newPhone"
      label="newPhone"
      component={RenderFormFieldNew}
      type="text"
      placeholder="Mobile phone number"
      validate={phone}
      startFocused={true}
    />
  </div>
);

export default NewPhoneNumber;
